import { createContext, ReactNode, useContext } from "react";
import { io, Socket } from "socket.io-client";

// Define the context type
interface SocketContextType {
  socket: Socket | null;
}

// Create a context with proper typing
const SocketContext = createContext<SocketContextType>({ socket: null });

interface SocketProviderProps {
  children: ReactNode;
}

const SocketProvider = ({ children }: SocketProviderProps) => {
  // Initialize your Socket.IO connection here with proper typing
  const socket: Socket = io(process.env.REACT_APP_CONVERSATION_SOCKET_URL);

  // Provide the socket value to the context
  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

// Custom hook to access the socket from any component
const useSocket = (): Socket => {
  const { socket } = useContext(SocketContext);

  if (!socket) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};

export { SocketProvider, useSocket };